<template>
  <div v-click-outside="close">
    <button
      class="offer-search__dropdown-button"
      :class="{'offer-search__dropdown-button--active': open}"
      @click="toggle"
      @click.stop
    >
      <span class="screen-reader-text">Avaa valikko</span>
    </button>

    <div
      v-if="open"
      class="offer-search__dropdown"
      @click.stop
    >
      <button
        class="offer-search__action-button"
        @click="copy"
        @click.stop
      >
        Kopioi
      </button>
      <button
        v-if="currentUserCanDelete"
        class="offer-search__action-button"
        @click="confirmDeletion"
        @click.stop
      >
        Poista
      </button>
    </div>

    <delete-offer-modal
      :offer-id="offerId"
      :display="displayDeleteConfirmation"
      :nonce="nonce"
      @cancel="displayDeleteConfirmation = false"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ClickOutside from 'vue-click-outside';
import DeleteOfferModal from './delete-offer-modal.vue';

export default {
    components: {
        DeleteOfferModal,
    },
    directives: {
        ClickOutside,
    },
    props:{
        offerId: {
            type: Number,
            default: 0,
        },
        nonce: {
            type: String,
            default: '',
        },
        currentUserCanDelete: Boolean,
    },

    data: function() {
        return {
            open: false,
            displayDeleteConfirmation: false,
        }
    },

    methods: {
        toggle() {
            this.open = !this.open;
        },

        close() {
            this.open = false;
        },

        copy() {
            let config = {
                headers: {
                    'X-WP-Nonce': this.nonce,
                },
            }

            axios.post('/wp-json/modeo/v2/offer/copy', {'offer_id': this.offerId}, config)
            .then(() => {
                window.location.reload();
            })
            .catch(e => {
                console.log('Error: ', e);
            });
        },

        confirmDeletion() {
            this.displayDeleteConfirmation = true;
        },
    },
}
</script>
